const ROOM_PATH = (roomId: string, calendarId: string) =>
  `/api/v2/pricemulti/room/id_room/${roomId}/id_calendar/${calendarId}/`

export default function(api: GlobalFetch) {
  return async function(roomId: string, calendarId: string) {
    const response = await api.fetch(ROOM_PATH(roomId, calendarId))
    return await handleResponse(response)
  }
}

export async function handleResponse(response: Response) {
  const json = await response.json()
  return json.items && json.items[0]
}
